import React from 'react';
import PropTypes from 'prop-types';
import {
    REGISTRY_STATUS_ACTIVE,
    REGISTRY_STATUS_INACTIVE,
    REGISTRY_STATUS_OFFLINE,
    CONTEXT_TYPE_FILE,
    MESSAGE_TYPE_CONTEXT,
} from '@evo/chat-core';
import { t } from 'c-3po';
import classSet from 'classnames';

import * as h from '../../../../../../libs/helpers';

import { Icon } from '../../../../../ui/icon';

// styles
import css from './chatRow.sss';

// images
import BlockIconSvg from './images/block.icon.svg';


export const ChatRow = ({chat, openRoom, userRole}) => {
    const roomBaned = chat[h.banMap[userRole]];
    const lastMessageBody = (
        chat.type === MESSAGE_TYPE_CONTEXT
        && chat.context_item_type === CONTEXT_TYPE_FILE
    ) ? t`Фото` : chat.body;

    const indicatorClasses = classSet(
        css.indicator,
        {
            [css.indicatorActive]: chat.status === REGISTRY_STATUS_ACTIVE,
            [css.indicatorInactive]: chat.status === REGISTRY_STATUS_INACTIVE,
            [css.indicatorOffline]: chat.status === REGISTRY_STATUS_OFFLINE,
        },
    );

    return (
        <div
            key={`${chat.room_ident}`}
            className={css.root}
            data-qaid='chat_blocks'
            onClick={() => openRoom(chat.room_ident)}
        >
            <div className={css.mainInfo}>
                <div className={css.nameHolder}>
                    <span
                        className={h.newMsgCondition(chat) ? css.nameBold : css.name}
                        data-qaid='chat_name_btn'
                    >
                        {chat.room_name}
                    </span>
                    <span className={indicatorClasses} />
                </div>
                <div
                    className={css.text}
                    data-qaid='last_msg_text_field'
                    id={`lastChatsMsg${chat.room_ident}`}
                >
                    {lastMessageBody}
                </div>
            </div>
            <div className={css.additionalInfo}>
                {roomBaned ? (
                    <React.Fragment>
                        <Icon className={css.banedIcon} glyph={BlockIconSvg} />
                        <span className={css.banedText}>
                            {t`Заблокирован`}
                        </span>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <span className={css.time}>
                            {!!chat.date_sent && h.formatChatListDate(chat.date_sent)}
                        </span>
                        {h.newMsgCondition(chat) && (
                            <div className={css.unread}>
                                <span className={css.unreadStatus} />
                                {/* TODO use for count <span className={css.unreadCounter}>7</span> */}
                            </div>
                        )}
                    </React.Fragment>
                )}
            </div>
        </div>
    );
};

ChatRow.propTypes = {
    chat: PropTypes.object,
    openRoom: PropTypes.func,
    userRole: PropTypes.string,
};
